module.exports = __webpack_public_path__ + "img/back4.80533354.jpg";